import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 group">
            <div className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-lg">
              <i className="ri-book-2-line text-background-50 text-lg"></i>
            </div>
            <span className="text-lg font-semibold text-foreground-950 whitespace-nowrap" style={{ fontFamily: 'var(--font-heading)' }}>
              秘密教学
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-6">
            <Link
              to="/"
              className={`text-sm transition-colors whitespace-nowrap ${
                location.pathname === '/'
                  ? 'text-primary-500 font-medium'
                  : 'text-foreground-700 hover:text-foreground-950'
              }`}
            >
              首页
            </Link>
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`text-sm transition-colors whitespace-nowrap ${
                  location.pathname.includes(cat.slug)
                    ? 'text-primary-500 font-medium'
                    : 'text-foreground-700 hover:text-foreground-950'
                }`}
              >
                {cat.name}
              </Link>
            ))}
            <Link
              to="/about"
              className={`text-sm transition-colors whitespace-nowrap ${
                location.pathname === '/about'
                  ? 'text-primary-500 font-medium'
                  : 'text-foreground-700 hover:text-foreground-950'
              }`}
            >
              关于我们
            </Link>
          </div>

          <button
            className="md:hidden w-10 h-10 flex items-center justify-center rounded-md text-foreground-700 hover:bg-background-100 transition-colors"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="菜单"
          >
            <i className={`ri-${mobileOpen ? 'close' : 'menu'}-line text-xl`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70">
          <div className="px-4 py-3 space-y-1">
            <Link to="/" className="block px-3 py-2 rounded-md text-sm text-foreground-700 hover:bg-background-100 transition-colors">
              首页
            </Link>
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className="block px-3 py-2 rounded-md text-sm text-foreground-700 hover:bg-background-100 transition-colors"
              >
                {cat.name}
              </Link>
            ))}
            <Link to="/about" className="block px-3 py-2 rounded-md text-sm text-foreground-700 hover:bg-background-100 transition-colors">
              关于我们
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}